<template>
  <tr class="admin-data-table-item">
    <td>
      {{ $date.format(item.date) }}
    </td>
    <td>
      {{ numberFormat(item.totalUser) }}
    </td>

    <td>
      {{ numberFormat(item.uniqueUser) }}
    </td>

    <td>
      {{ numberFormat(item.newUser) }}
    </td>

    <td>
      {{ numberFormat(item.access) }}
    </td>

    <td>
      {{ numberFormat(item.impress) }}
    </td>

    <td>
      {{ numberFormat(item.abandonment) }}
    </td>

  </tr>
</template>

<script>
    export default {
      props: {
        item: {
          type: Object,
          required: true
        }
      },
      methods: {
        numberFormat(number) {
          return new Intl.NumberFormat('pt-BR').format(number)
        }
      }
    }
</script>

<style lang="scss" scoped>
</style>
